import { useQuery } from "@tanstack/react-query";
import { createFileRoute, useParams } from "@tanstack/react-router";
import { TicketWorkspaceFormPanel } from "@/features/tickets/components";
import { ticketQueryOptions } from "@/services/ticket";

export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/tickets/(ticket)/$ticketId/workspace/form",
)({
	component: TicketWorkspaceFormTab,
});

function TicketWorkspaceFormTab() {
	const params = useParams({
		from: "/_authenticated/(web-app)/_web/web/$orgId/tickets/(ticket)/$ticketId/workspace/form",
	});
	const ticketById = useQuery(
		ticketQueryOptions.detail(params.ticketId, {
			organizationId: params.orgId,
		}),
	);

	return (
		<TicketWorkspaceFormPanel
			ticket={ticketById.data}
			ticketId={params.ticketId}
			organizationId={params.orgId}
			isTicketPending={ticketById.isPending}
		/>
	);
}
